import api from "@/services/api.service";

/**
 * Lodgify channel-manager store. Counterpart of the Hostaway store — kept
 * separate on purpose. Hits the backend /lodgify/* endpoints. The branch's
 * Lodgify API key is stored in the branch channelSecret field.
 */
export const lodgifyModule = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        // Pull bookings for a single property into the CRM (uses the channel-manager dispatcher).
        syncLodgifyReservations(actions, propertyId) {
            return api.sendRequest('lodgify/sync/' + propertyId, null, {}).then(
                (ans) => {
                    actions.dispatch('notifications/success',
                        {title: 'Lodgify', message: 'Reservation sync triggered'}, {root: true});
                    return ans;
                },
                (error) => rejectWith(actions, error)
            );
        },
        getLodgifyProperties(actions, branchId) {
            return api.get('lodgify/properties/' + branchId).then(
                (ans) => ans['Properties'],
                (error) => rejectWith(actions, error)
            );
        },
        getLodgifyBookings(actions, {branchId, stayFilter}) {
            return api.get('lodgify/bookings/' + branchId, stayFilter ? {stayFilter} : null).then(
                (ans) => ans['Bookings'],
                (error) => rejectWith(actions, error)
            );
        },
        getLodgifyBookingsPerProperty(actions, {branchId, propertyId}) {
            return api.get('lodgify/bookings/' + branchId + '/property/' + propertyId).then(
                (ans) => ans['Bookings'],
                (error) => rejectWith(actions, error)
            );
        },
        listLodgifyWebhooks(actions, branchId) {
            return api.get('lodgify/webhooks/' + branchId).then(
                (ans) => ans['Webhooks'],
                (error) => rejectWith(actions, error)
            );
        },
        subscribeLodgifyWebhooks(actions, branchId) {
            return api.sendRequest('lodgify/webhooks/' + branchId + '/subscribe', null, {}).then(
                (ans) => {
                    actions.dispatch('notifications/success',
                        {title: 'Lodgify', message: 'Webhooks subscribed'}, {root: true});
                    return ans['Subscribed'];
                },
                (error) => rejectWith(actions, error)
            );
        },
        getLodgifyAvailability(actions, {branchId, propertyId, start, end}) {
            return api.get('lodgify/availability/' + branchId + '/' + propertyId, {start, end}).then(
                (ans) => ans['Availability'],
                (error) => rejectWith(actions, error)
            );
        },
        getLodgifyRates(actions, {branchId, propertyId, start, end}) {
            return api.get('lodgify/rates/' + branchId + '/' + propertyId, {start, end}).then(
                (ans) => ans['Rates'],
                (error) => rejectWith(actions, error)
            );
        },
    }
};

function rejectWith(actions, error) {
    actions.dispatch('notifications/error', {
        title: {text: '%s - failed', arguments: ['Lodgify']},
        message: (typeof error === 'object' && error.message !== undefined ? error.message : error),
    }, {root: true});
    return Promise.reject(error);
}
